{
  "povzetek": {
    "title": "Riepilogo",
    "skupno30": "Ultimi 30 giorni",
    "skupno90": "Ultimi 90 giorni",
    "skupno365": "Ultimi 365 giorni",
    "vsiO": "Tutti i voli completati",
    "povprecje": "Durata media del volo",
    "najveckratV": "L'aereo più utilizzato"
  },
  "table": {
    "datum": "Data",
    "letalisce": "Aeroporto",
    "ttof": "TTOF",
    "vzlet": "Decollo",
    "diaryTitle": "Appunti di diario"
  },
  "modal": {
    "datum": "Data:",
    "casL": "Tempo totale di volo:",
    "pristankiD": "Numero di atterraggi (giorno):",
    "pristankiN": "Numero di atterraggi (notte):",
    "op": "Condizioni operative:",
    "vp": "Ruolo del pilota:",
    "fstd": "Tempo FSTD:",
    "odhod": "Partenza:",
    "krajO": "Luogo di partenza:",
    "prihod": "Arrivo:",
    "krajP": "Luogo di arrivo:",
    "zrakoplov": "Aeromobile:",
    "reg": "Registrazione:",
    "vodjaZ": "Nome del comandante:",
    "opomba": "Nota:"
  },
  "labels": {
    "casO": "Ora di partenza:",
    "casP": "Ora di arrivo:",
    "model": "Modello dell'aeromobile:",
    "reg": "Registrazione dell'aeromobile:",
    "vodjaZ": "Nome del comandante:",
    "posadka": "Equipaggio singolo / multiplo:",
    "pogoji": "Condizioni di volo:",
    "pD": "Giorno",
    "pN": "Notte",
    "stPristankov": "Numero di atterraggi:",
    "ttof": "Ttof:",
    "op": "Condizioni operative:",
    "opD": "Diurno",
    "opN": "Notturno",
    "vp": "Ruolo del pilota:",
    "fstd": "Tempo FSTD:",
    "opomba": "Nota:",
    "pristanek": "Seleziona atterraggio:",
    "regL": "Seleziona registrazione dell'aliante:"
  },
  "buttons": {
    "urediPodatke": "Modifica dati",
    "posodobiPodatke": "Aggiorna dati",
    "brisiZapis": "Elimina record",
    "brisiIzbiro": "Cancella selezione",
    "natisni": "Stampa",
    "poslji": "Invia"
  }
}